import { render, staticRenderFns } from "./TreemapAreaFailedProduct.vue?vue&type=template&id=4cdca580&lang=pug&"
import script from "./TreemapAreaFailedProduct.vue?vue&type=script&lang=ts&"
export * from "./TreemapAreaFailedProduct.vue?vue&type=script&lang=ts&"
import style0 from "./TreemapAreaFailedProduct.vue?vue&type=style&index=0&id=4cdca580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports